import {
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

import { useRootLayoutData } from "~/root";

interface SearchContextType {
  searchState: { value: string };
  setSearchState: Dispatch<SetStateAction<{ value: string }>>;
  isDialogVisible: boolean;
  setIsDialogVisible: (v: boolean) => void;
  isSuggestionsOpen: boolean;
  setIsSuggestionsOpen: (v: boolean) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider = ({ children }: { children: ReactNode }) => {
  const { DEFAULT_SEARCH_TERM } = useRootLayoutData();
  const [searchState, setSearchState] = useState({
    value: "",
  });
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [isSuggestionsOpen, setIsSuggestionsOpen] = useState(false);

  return (
    <SearchContext.Provider
      value={{
        searchState,
        setSearchState,
        isDialogVisible,
        setIsDialogVisible,
        isSuggestionsOpen,
        setIsSuggestionsOpen,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearchContext must be used within a SearchProvider");
  }
  return context;
};
